export const de = {
  nav: {
    by: "von codemenschen.at",
    ideas: "Apps",
    create: "Eigene Idee",
    how: "So funktioniert's",
    pricing: "Preise",
    faq: "FAQ",
    cta: "Apps ansehen",
    account: "Meine Projekte",
    login: "Anmelden",
  },
  hero: {
    eyebrow: "App-Entwicklung · Made in Vienna",
    titleA: "Deine App.",
    titleB: "Dein Eigentum.",
    lede: "Wähle eine fertige App-Idee oder beschreib deine eigene. Du siehst vorab einen Fixpreis, zahlst online, und unsere KI-Fabrik baut, testet und liefert die fertige App, inklusive Code und aller Rechte.",
    ctaIdeas: "App-Ideen ansehen",
    ctaCreate: "Eigene Idee beschreiben",
    chips: [
      "Fixpreis, sichtbar vor der Zahlung",
      "Code und Rechte gehören dir",
      "Stripe-Checkout, Erstattung wenn wir nicht liefern",
    ],
  },
  stats: {
    apps: "App-Ideen bereit zum Bau",
    price: "kleinster Fixpreis",
    ownN: "100 %",
    own: "des Codes und der Rechte gehen an dich",
  },
  how: {
    eyebrow: "So funktioniert's",
    title: "Vier Schritte.",
    cta: "Verfügbare App-Ideen ansehen →",
    steps: [
      { h: "Wählen oder beschreiben", p: "Nimm eine Idee aus dem Katalog oder beschreib deine eigene App in einfachen Worten." },
      { h: "Fixpreis vorab", p: "Du siehst Umfang, Preis und Liefer-Schätzung, bevor du einen Cent zahlst." },
      { h: "Wir bauen und testen", p: "Unsere KI-Entwicklungs-Pipeline baut deine App; Menschen prüfen jedes Release vor der Auslieferung." },
      { h: "Alles gehört dir", p: "Code, App und Store-Eintrag sind deine, veröffentlicht unter deinem eigenen Developer-Account." },
    ],
  },
  split: {
    eyebrow: "Arbeitsteilung",
    title: "Wir bauen die Software. Du triffst die Entscheidungen.",
    weH: "Was wir tun",
    we: [
      "Jedes Feature designen, entwickeln und testen",
      "Die Build-Pipeline und jedes Release betreiben",
      "Code, Repository und Store-Eintrag übergeben",
      "Store-Assets vorbereiten und, wenn du willst, die Kampagnen",
    ],
    youH: "Was du tust",
    you: [
      "Eine Idee wählen oder deine eigene App beschreiben",
      "Umfang und Fixpreis vor der Zahlung freigeben",
      "Den Preview-Build prüfen und Korrekturen anfordern",
      "Entscheiden, wann veröffentlicht und wann geworben wird",
    ],
    note: "Du musst keine Entwickler einstellen und keine Server betreiben. Das deckt der Fixpreis ab.",
  },
  ideas: {
    eyebrow: "Verfügbare App-Ideen",
    title: "Jede Idee zeigt Preis und Umfang vorab.",
    lede: "Ausgewählt von unserer KI-Analyse von App-Store-Daten: echte Beschwerden, echte Lücken. Jede Idee wird exklusiv für einen Kunden gebaut. Einmal vergeben, ist sie weg.",
    note: "⚠ Alle Marktzahlen sind KI-generierte Schätzungen aus öffentlichen Quellen, keine Messungen.",
    from: "Fixpreis",
    delivery: "Liefer-Schätzung",
    type: "App-Typ",
    built: "Für einen Kunden gebaut",
    view: "Idee ansehen →",
  },
  createBanner: {
    title: "Deine eigene Idee?",
    p: "Beschreib deine App in wenigen Klicks. Du bekommst sofort eine Preis-Schätzung und den vollen Umfang vor dem Checkout.",
    cta: "App-Assistent starten →",
  },
  honest: {
    eyebrow: "Vor dem Kauf",
    title: "Was du wissen solltest.",
    items: [
      { h: "Lieferzeiten sind Schätzungen.", p: "Die Build-Pipeline ist schnell, aber die Review-Zeiten der App Stores liegen außerhalb unserer Kontrolle. Wir zeigen Schätzungen, keine Versprechen." },
      { h: "Verbundene Apps haben eine Monatsgebühr.", p: "Apps, die Accounts, Sync oder eine Datenbank brauchen, laufen auf unseren Servern und tragen eine monatliche Hosting- und Wartungsgebühr, sichtbar vor dem Checkout, nie danach." },
      { h: "Scheitert der Bau, bekommst du dein Geld zurück.", p: "Wenn unsere Pipeline plus unsere menschlichen Entwickler den vereinbarten Umfang nicht liefern können, erstatten wir den Entwicklungspreis. Das ist der Deal." },
      { h: "Veröffentlicht wird unter deinen Accounts.", p: "Apple und Google verlangen, dass solche Apps unter deinem eigenen Developer-Account erscheinen (Apple 99 $/Jahr, Google 25 $ einmalig). Wir richten ihn mit dir ein." },
    ],
  },
  pricing: {
    eyebrow: "Preise",
    title: "Jeder Euro, nachvollziehbar.",
    note: "Es gibt keine weiteren Gebühren. Werbebudget ist immer von unseren Gebühren getrennt und fließt 1:1 in Anzeigen.",
    items: [
      { h: "App-Entwicklung", fig: "149–1.500 €", p: "Fixpreis, sichtbar mit dem vollen Umfang vor dem Checkout." },
      { h: "Store-Publishing", fig: "79 € einmalig", p: "Optional. Icon, Screenshots, Listing-Text und die Einreichung." },
      { h: "Developer-Account", fig: "49 € einmalig", p: "Optional. Wir richten deine Apple- und Google-Accounts gemeinsam mit dir ein." },
      { h: "Launch-Marketing", fig: "ab 129 €", p: "Optional. Kampagnen-Konzept, Anzeigentexte und die Creatives." },
      { h: "Hosting & Wartung", fig: "0 € oder monatlich", p: "Lokale Apps kosten nichts. Verbundene Apps tragen eine Monatsgebühr, sichtbar vor dem Checkout." },
      { h: "Werbebudget", fig: "Dein Betrag", p: "Optional. Fließt 1:1 in Anzeigen, immer getrennt von unseren Gebühren." },
    ],
  },
  about: {
    eyebrow: "Wer das baut",
    title: "Ein echtes Unternehmen in Wien, keine Landing-Page.",
    p: "Gebaut und betrieben von codemenschen.at, einem Software-Unternehmen in Wien. Schau uns nach, lies das Impressum, dann weißt du genau, wer verantwortlich ist.",
    cta: "codemenschen.at besuchen ↗",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Die Fragen, die du stellen solltest.",
    cta: "Fragen geklärt? Zu den Ideen →",
    items: [
      { q: "Gehört mir die App wirklich?", a: "Ja. Du beauftragst die Entwicklung; die fertige App, ihr Code und ihr Store-Eintrag gehören dir." },
      { q: "Was, wenn mir das Ergebnis nicht gefällt?", a: "Du prüfst einen Preview-Build vor dem Release und kannst Korrekturen im vereinbarten Umfang anfordern. Können wir den Umfang nicht liefern, gibt es eine Erstattung." },
      { q: "Könnt ihr die App auch vermarkten?", a: "Ja. Ein optionales Launch-Marketing-Paket plus ein separates Werbebudget, das 1:1 in Kampagnen fließt." },
    ],
  },
  final: {
    title: "Deine App wartet.",
    lede: "Fertige Ideen mit Fixpreis und vollem Umfang, oder deine eigene Idee im Assistenten.",
    cta1: "App-Ideen ansehen →",
    cta2: "Eigene Idee beschreiben",
  },
  bar: {
    title: "Deine App wartet.",
    sub: "Fixpreis, sichtbar vor der Zahlung",
    cta: "App-Ideen ansehen →",
  },
  detail: {
    price: "Fixer Entwicklungspreis",
    hosting: "Hosting & Wartung",
    hostingA: "0 €/Monat, läuft vollständig am Gerät",
    weeks: "Liefer-Schätzung",
    weeksUnit: "Wochen",
    typeA: "Lokale App",
    typeB: "Verbundene App",
    cta: "Diese App bauen lassen",
    ctaTaken: "Bereits für einen Kunden gebaut",
    why: "Warum diese Idee",
    market: "Markt-Überblick",
    aud: "Für wen sie ist",
    sample: "Beispiel-Listing, KI-geschätzte Daten",
    back: "← Alle App-Ideen",
    estimateNote: "Alle Zahlen sind KI-generierte Schätzungen aus öffentlichen Quellen und als solche markiert, bis echte Daten existieren.",
  },
  wizard: {
    title: "Beschreib deine App",
    lede: "Vier kurze Fragen. Der Preis aktualisiert sich live. Bezahlt wird erst, nachdem du den vollen Umfang gesehen hast.",
    idea: "Was soll die App tun?",
    ideaPh: "z. B. Eine Buchungs-App für meine Tanzschule mit Kursplan und Zahlungen …",
    ideaExamplesLabel: "Beispiele:",
    ideaExamples: [
      "Terminbuchung für meinen Friseursalon: Kunden wählen Zeit und Leistung, bekommen eine Erinnerung per Push.",
      "Packliste für Reisen: Listen anlegen, Gegenstände abhaken, auch offline nutzbar.",
      "Trinkgeld-Rechner: Betrag eingeben, Prozent wählen, Rechnung auf mehrere Personen teilen.",
    ],
    ideaHint: "Tipp: Wer nutzt die App, was macht sie, und welche drei Dinge kann man darin tun?",
    hintsLabel: "Aus deiner Beschreibung:",
    hintsDismiss: "ausblenden",
    refine: "✨ Idee schärfen",
    refining: "Wird geschärft …",
    refineNote: "KI-Vorschlag. Du entscheidest, was übernommen wird. Bis zu 3 Runden pro Idee.",
    refineTitle: "Vorschlag",
    refineAccept: "Beschreibung übernehmen",
    refineAccepted: "Übernommen ✓",
    refineQuestions: "Kurz klären:",
    refineFeatures: "Funktionen übernehmen:",
    refineAgain: "Mit den Antworten nochmal schärfen",
    refineLimit: "Das Tageslimit für den Assistenten ist erreicht. Die Beschreibung kannst du natürlich weiter selbst bearbeiten.",
    refineUnavailable: "Der Assistent ist gerade nicht erreichbar. Schreib die Beschreibung einfach selbst. Das reicht völlig.",
    refineOffTopic: "Das klingt nicht nach einer App-Idee. Beschreib, was die App für wen tun soll.",
    audience: "Für wen ist sie?",
    audOpts: { consumer: "Privatnutzer", b2b: "Unternehmen", both: "Beide" },
    platform: "Wo soll sie laufen?",
    platOpts: { web: "Web-App", mobile: "Mobile App", both: "Web + Mobil" },
    features: "Welche Funktionen braucht sie?",
    featureLabels: {
      auth: "Nutzerkonten / Login",
      pay: "Zahlungen",
      dash: "Dashboard / Statistiken",
      ai: "KI-Funktionen",
      notif: "Push-Benachrichtigungen",
      api: "Externe Anbindungen",
      offline: "Offline-Fähigkeit",
      i18n: "Mehrsprachigkeit",
    } as Record<string, string>,
    estTitle: "Deine Schätzung",
    estMissing: "Es fehlt noch:",
    estPrice: "Fixer Entwicklungspreis",
    estWeeks: "Liefer-Schätzung",
    estType: "App-Typ",
    estHosting: "Hosting & Wartung",
    estHostingA: "0 €/Monat (lokale App)",
    estNote: "Der finale Umfang wird vor dem Checkout bestätigt. Verbundene Apps (Accounts, Sync, Datenbank) laufen auf unseren Servern zur angezeigten Monatsgebühr.",
    cta: "Weiter zu Umfang & Checkout",
  },
  checkout: {
    title: "Checkout",
    summary: "Deine Bestellung",
    development: "App-Entwicklung",
    packagesTitle: "Optionale Pakete",
    packages: {
      storePublishing: "Store-Publishing-Paket",
      transferAssist: "Developer-Account-Einrichtung",
      marketingLaunch: "Launch-Marketing-Paket",
    } as Record<string, string>,
    storeLocalesTitle: "Sprachen des Store-Listings",
    storeLocalesNote: "App-Name, Untertitel, Beschreibung, Keywords und Release Notes werden für jede angehakte Sprache erzeugt.",
    localeNames: { de: "Deutsch", en: "Englisch" } as Record<string, string>,
    adBudget: "Monatliches Werbebudget (optional)",
    adBudgetNote: "Separat abgerechnet nach Kampagnen-Freigabe, fließt 1:1 in Anzeigen und ist nie Teil der heutigen Zahlung.",
    adNone: "Vorerst keine Anzeigen",
    email: "Deine E-Mail",
    step1: "1 · Leistungsumfang",
    step2: "2 · Werbebudget",
    step3: "3 · Baustart und Widerruf",
    step4: "4 · E-Mail und Bedingungen",
    termsTitle: "Bedingungen",
    termsLabel: "Ich habe die Bedingungen und die Widerrufsbelehrung gelesen und stimme ihnen zu.",
    termsLink: "Bedingungen lesen",
    withdrawalLink: "Widerrufsbelehrung",
    waiverTitle: "Baustart & Widerrufsrecht",
    waiverLabel: "Ich verlange ausdrücklich, dass mit der Arbeit sofort begonnen wird, und nehme zur Kenntnis, dass ich mein Widerrufsrecht mit Beginn der Leistung verliere.",
    waiverOff: "Ohne diese Zustimmung startet der Bau nach der 14-tägigen Widerrufsfrist. Dein Widerrufsrecht bleibt vollständig erhalten.",
    hostingLine: "Hosting & Wartung (monatlich, ab Lieferung)",
    totalToday: "Heute fällig",
    firstYear: "Gesamt in den ersten 12 Monaten",
    pay: "Sicher zahlen mit Stripe →",
    working: "Checkout wird vorbereitet …",
    staging: "⚠ Die Zahlung ist noch nicht verbunden (Staging). Deine Anfrage wurde gespeichert. Wir melden uns per E-Mail.",
    missingQuote: "Kein Angebot gefunden. Starte bei einer App-Idee oder im Assistenten.",
    errors: { generic: "Etwas ist schiefgelaufen. Bitte versuch es erneut." },
  },
  success: {
    title: "Danke, Zahlung erhalten.",
    p: "Dein Projekt wurde angelegt. Du bekommst eine E-Mail mit einem Anmelde-Link zu deinem Projekt-Dashboard; dort übernimmt die Build-Pipeline deine App.",
    cta: "Zu deinen Projekten",
  },
  project: {
    timeline: "Pipeline",
    criteria: "Abnahmekriterien",
    builds: "Builds",
    tabs: { app: "App", store: "Store", marketing: "Marketing", activity: "Verlauf" },
    approveTitle: "Freigabe",
    buildsPending: "Noch kein Build. Die Factory arbeitet.",
    criteriaSummary: "{passed} von {total} Abnahmekriterien bestanden",
    assetsEmpty: "Die Store-Texte entstehen nach deiner Freigabe.",
    download: "Herunterladen",
    platformNames: { bundle: "Quellcode (tar.gz)", android: "Android (.apk)", ios: "iOS", web: "Web-Preview" } as Record<string, string>,
    openPreview: "Im Browser öffnen →",
    previewHint: "Die Web-Preview startet die App direkt im Browser, ohne Installation. Die installierbare Android-App (.apk) bauen wir nach deiner Freigabe.",
    previewTitle: "Live-Vorschau",
    previewEmpty: "Deine App erscheint hier, sobald die Factory die erste Vorschau gebaut hat.",
    previewReload: "Neu laden",
    previewOpen: "Öffnen ↗",
    buildRunning: "Android-Build läuft. Das .apk erscheint hier, sobald es fertig ist (Warteschlange bis ~30 Minuten).",
    buildFailed: "Der Android-Build ist fehlgeschlagen. Unsere Entwickler wurden benachrichtigt und bauen ihn von Hand. Die Web-Preview und der Quellcode bleiben verfügbar.",
    sourceHint: "Der Quellcode gehört dir und ist jederzeit herunterladbar. Hilfe beim Umzug in deine eigenen Accounts gibt es mit dem Developer-Account-Paket.",
    approve: "Preview freigeben → App bauen",
    approveHint: "Du bist mit der Web-Preview zufrieden: Das Projekt wird READY, die Store-Texte entstehen und der Android-Build (.apk) startet. Änderungen davor sind günstiger: jeder Build kostet Zeit und Kontingent.",
    approved: "Freigegeben. Das Projekt ist READY.",
    failed: "Die Pipeline konnte nicht abschließen. Unsere Entwickler wurden benachrichtigt und übernehmen.",
    changesTitle: "Änderungen anfordern",
    changesHint: "Noch nicht ganz richtig? Beschreib, was geändert werden soll. Die App wird angepasst, neu getestet und ein neuer Preview gebaut. Noch {left} von {max} kostenlosen Runden.",
    changesPh: "z. B. Der Hauptbutton soll grün sein, und der Startbildschirm soll das heutige Datum anzeigen.",
    changesCareHint: "Beschreib, was anders sein soll. Die App wird angepasst, neu getestet und ein neuer Preview gebaut. Eine veröffentlichte App bleibt währenddessen online.",
    careTitle: "Appwerk Care",
    careOffer: "Oder {price}/Monat: Änderungen unbegrenzt, jederzeit kündbar, endet zum Ende des Abrechnungsmonats.",
    careBenefits: [
      "Unbegrenzte Änderungsrunden: Fixes, Texte, Layout, kleine Anpassungen",
      "Updates für neue iOS- und Android-Versionen",
      "Monatlich kündbar, keine Mindestlaufzeit",
    ],
    careStart: "Care starten für {price}/Monat →",
    careActiveHint: "aktiv, Änderungen sind unbegrenzt inklusive.",
    careEndsOn: "Care endet am {date}.",
    careCancel: "Care kündigen",
    careCancelConfirm: "Care zum Ende des Abrechnungsmonats kündigen? Bis dahin bleiben Änderungen inklusive.",
    carePastDue: "Die letzte Care-Zahlung ist fehlgeschlagen. Bitte das Zahlungsmittel über den Stripe-Link in der E-Mail aktualisieren. Bis dahin gelten die normalen Konditionen.",
    crHint: "Je konkreter, desto besser das Ergebnis: Welcher Bildschirm, welches Element, wie ist es jetzt, wie soll es sein?",
    crRefine: "✨ Wunsch schärfen",
    crRefining: "Wird geschärft …",
    crRefineNote: "Prüft vor der Bestellung, ob der Wunsch in eine Änderungsrunde passt. Bis zu 3 Runden.",
    crRefineAccept: "Formulierung übernehmen",
    crRefineAccepted: "Übernommen ✓",
    crRefineQuestions: "Kurz klären:",
    crRefineAgain: "Mit den Antworten nochmal schärfen",
    crRefineOutOfScope: "Passt nicht in eine Änderungsrunde:",
    crRefineLimit: "Das Tageslimit für den Assistenten ist erreicht. Du kannst den Wunsch natürlich weiter selbst formulieren.",
    crRefineUnavailable: "Der Assistent ist gerade nicht erreichbar. Formuliere den Wunsch einfach selbst.",
    crRefineOffTopic: "Das klingt nicht nach einem Änderungswunsch an der App. Beschreib, was anders sein soll.",
    changesSend: "Änderungswunsch senden",
    changesPaidHint: "Kostenlose Runden aufgebraucht oder App bereits veröffentlicht: eine Änderungsrunde kostet {price} (einmalig). Die Arbeit startet direkt nach der Zahlung und endet mit einem neuen Preview zur Freigabe. Eine veröffentlichte App bleibt währenddessen online.",
    changesPay: "{price} zahlen & Änderung beauftragen →",
    changesPayLink: "Zahlung abschließen →",
    changesInProgress: "Wir arbeiten an deinem Änderungswunsch. Diese Seite aktualisiert sich automatisch.",
    changesHistory: "Änderungswünsche",
    changesRound: "Runde",
    crStatus: {
      awaiting_payment: "Zahlung ausstehend",
      paid: "Bezahlt, wartet",
      in_progress: "In Arbeit",
      done: "Erledigt, neuer Preview gebaut",
      out_of_scope: "Außerhalb des bestellten Umfangs",
      failed: "Konnte nicht umgesetzt werden, wir wurden benachrichtigt",
    } as Record<string, string>,
    back: "← Alle Projekte",
    signInNeeded: "Du bist auf diesem Gerät nicht angemeldet. Fordere einen Anmelde-Link an. Danach landest du direkt wieder bei diesem Projekt.",
    signIn: "Anmelde-Link anfordern",
    notFound: "Dieses Projekt konnte nicht geladen werden. Es gehört zu einem anderen Konto, oder deine Sitzung ist abgelaufen. Melde dich erneut an.",
    open: "Details",
    assets: "Store-Assets",
    assetsHint: "Automatisch in den bestellten Store-Listing-Sprachen erzeugt. Vor dem Publishing prüfen.",
    kinds: {
      name: "App-Name",
      subtitle: "Untertitel",
      description: "Beschreibung",
      keywords: "Keywords",
      release_notes: "Release Notes",
    } as Record<string, string>,
    publishing: "Store-Publishing",
    publishingHint: "Apple und Google verlangen, dass solche Apps unter deinem eigenen Developer-Account erscheinen (Apple 99 $/Jahr, Google 25 $ einmalig). Starte das Publishing, lege die Accounts mit unserer Anleitung an. Die Einreichung übernehmen wir.",
    publishStart: "Publishing starten",
    stores: { apple: "Apple App Store", google: "Google Play" } as Record<string, string>,
    accountPh: "Deine Developer-Account-ID / Team-Name",
    accountSave: "Speichern",
    subStatus: {
      waiting_account: "Warten auf deinen Developer-Account",
      preparing: "Wir bereiten die Einreichung vor",
      submitted: "Beim Store eingereicht",
      in_review: "Im Store-Review",
      live: "Live im Store 🎉",
      rejected: "Abgelehnt, wir kümmern uns",
    } as Record<string, string>,
    marketing: "Marketing",
    marketingHint: "Dein Launch-Marketing-Paket: Wir erzeugen Kampagnen-Strategie, Ad-Copy und Landing-Texte für Google und Meta. Ohne deine Freigabe wird nichts veröffentlicht und kein Budget ausgegeben. Die Anzeigen selbst gehen in einem späteren Release live.",
    marketingGenerate: "Kampagnen-Entwürfe erzeugen",
    marketingGenerating: "Wird erzeugt, die Seite aktualisiert sich automatisch …",
    campaignApprove: "Inhalte freigeben",
    campaignReject: "Ablehnen",
    campaignStatus: {
      pending_approval: "Wartet auf deine Freigabe",
      approved: "Inhalte freigegeben",
      rejected: "Abgelehnt",
      live: "Live",
      ended: "Beendet",
    } as Record<string, string>,
    creativeKinds: {
      headline: "Headline",
      ad_copy: "Ad-Copy",
      landing: "Landing-Text",
      image_prompt: "Bild-Briefing",
    } as Record<string, string>,
  },
  admin: {
    title: "Werkstatt",
    loading: "Lädt…",
    noAccess: "Kein Zugang für dieses Konto.",
    goSignIn: "Zur Anmeldung",
    empty: "Nichts vorhanden.",
    libSearchHint: "Bildbeschreibung durchsuchen",
    libShared: "Freigegeben",
    libShare: "Freigeben",
    libUnshare: "Sperren",
    libDelete: "Löschen",
    libDeleteConfirm: "Dieses Bild endgültig löschen?",
    libOn: "Archiv an",
    libOff: "Archiv aus",
    libOffNote:
      "Das Archiv ist aus. Jede Anzeige bekommt ein neu erzeugtes Bild. Gesammelt wird trotzdem weiter.",
    libToggleHint: "Aus bedeutet: nicht suchen, sondern neu erzeugen.",
    libShareHint: "Ein freigegebenes Bild darf auch ein anderer Kunde bekommen.",
    libCaptionHint: "Zum Bearbeiten anklicken. Nach diesem Text wird gesucht.",
    refNote:
      "Gesammelte App-Screens zum Nachschlagen. Sie werden nie ausgeliefert. Der Prototyp-Generator liest nicht diese Bilder, sondern die Regeln, die daraus abgeleitet wurden.",
    refUnavailable: "Die Bibliothek ist auf diesem Server nicht eingebunden.",
    refSearchHint: "Notiz, Button-Text oder Quelle durchsuchen",
    refMedium: "Art",
    refScreenType: "Screen",
    refIndustry: "Branche",
    refPattern: "Muster",
    refScheme: "Helligkeit",
    refGrade: "Auflösung",
    refLabelState: "Gelabelt",
    refAll: "Alle",
    refYes: "ja",
    refNo: "nein",
    refCount: "{matched} von {total} Bildern, {labelled} gelabelt",
    refReset: "Filter zurücksetzen",
    refPrev: "Zurück",
    refNext: "Weiter",
    refPage: "Seite {page} von {pages}",
    refOpen: "Original öffnen",
    tabs: {
      overview: "Überblick",
      projects: "Projekte",
      ads: "Anzeigen",
      customers: "Kunden",
      prototypes: "Prototypen",
      library: "Bildarchiv",
      references: "Referenzen",
    },
    protoWhen: "Wann",
    protoKind: "Art",
    protoStatus: "Status",
    protoPrompt: "Was eingegeben wurde",
    protoTook: "Dauer",
    protoQa: "QA",
    protoOpen: "Öffnen",
    protoExpired: "abgelaufen",
    protoRepairs: "{n} Reparaturen",
    protoEmpty: "Noch kein Prototyp.",
    projectsTile: "Projekte",
    runsTile: "Pipeline-Läufe",
    connectionsTile: "Anzeigen-Konten",
    connected: "verbunden",
    notConnected: "nicht verbunden",
    missing: "fehlt",
    connectionsHint: "Live-Prüfung der Zugangsdaten: factory:ads-check auf dem Server.",
    adsTile: "Anzeigen",
    revenueTile: "Umsatz",
    customersTile: "Kunden",
    queued: "In Warteschlange",
    running: "Läuft",
    failed24h: "Fehlgeschlagen (24 h)",
    paidOrders: "Bezahlte Bestellungen",
    paidEur: "Bezahlt",
    hosting: "Hosting je Monat",
    orders: "Bestellungen",
    attention: "Braucht Aufmerksamkeit",
    allQuiet: "Nichts offen. Alles läuft.",
    kinds: {
      project_failed: "Projekt gescheitert",
      run_failed: "Stage gescheitert",
      run_stalled: "Stage hängt",
      ad_failed: "Anzeige gescheitert",
      prototype_qa: "Prototyp mit Mängeln",
    },
    retryStage: "Stage neu starten",
    rerender: "Neu rendern",
    stageQueued: "Stage eingereiht",
    statusForced: "Status gesetzt",
    adQueued: "Anzeige wird neu gerendert.",
    search: "Suchen",
    searchHint: "Projektname oder E-Mail",
    allStatuses: "Alle Status",
    project: "Projekt",
    status: "Status",
    customer: "Kunde",
    order: "Bestellung",
    open: "Öffnen",
    runStage: "Stage starten",
    forceStatus: "Status setzen",
    runs: "Läufe",
    events: "Verlauf",
    ad: "Anzeige",
  },
  lab: {
    title: "Anzeigen",
    intro: "Anzeigen, die auf dem Server erzeugt wurden. Noch nicht öffentlich.",
    signIn: "Melde dich an, um die Clips zu sehen.",
    goSignIn: "Zur Anmeldung",
    empty: "Noch keine Anzeigen vorhanden.",
    loading: "Lädt…",
    failed: "Clip konnte nicht geladen werden.",
    background: "Hintergrund",
    bgAuto: "Automatisch",
    bgSite: "Screenshot der Seite",
    bgPhoto: "KI-Foto",
    kind: "Art",
    kindVideo: "Video-Anzeige",
    kindImage: "Bild-Anzeige",
    open: "Ansehen",
    createTitle: "Neue Anzeige erzeugen",
    promptLabel: "Beschreib den Clip in einem Satz",
    promptHint: "Zum Beispiel: Ein kurzer Clip für Instagram, der zeigt, dass Kunden in zehn Sekunden einen Termin buchen.",
    project: "Projekt",
    format: "Format",
    vertical: "Hochkant",
    square: "Quadrat",
    landscape: "Quer",
    // Beschriftung je Format. Die Liste selbst kommt aus der API, damit ein neues Format
    // hier nur noch einen Namen braucht; fehlt der, zeigt die Auswahl den englischen aus der API.
    formats: {
      vertical: "Hochkant (Story, Reels)",
      square: "Quadrat (Feed)",
      landscape: "Quer (YouTube)",
      feed_portrait: "Feed hoch (4:5)",
      link: "Link-Anzeige (1,91:1)",
      gads_square: "Google Quadrat",
      gads_portrait: "Google hoch (4:5)",
    },
    angle: "Erzählweise",
    angleAuto: "Automatisch",
    angles: {
      problem_solution: "Problem und Lösung",
      before_after: "Vorher und nachher",
      founder: "Der Mensch dahinter",
      testimonial: "Aus Kundensicht",
      demo: "So läuft es ab",
      price_anchor: "Was es ersetzt",
      seasonal: "Zur Saison",
    },
    goal: "Ziel",
    goalAuto: "Automatisch",
    goals: {
      booking: "Termin buchen",
      call: "Anrufen oder schreiben",
      quote: "Angebot anfragen",
      buy: "Produkt kaufen",
      signup: "Konto anlegen",
      visit: "Website besuchen",
    },
    create: "Anzeige erzeugen",
    queued: "In der Warteschlange",
    rendering: "Wird gerendert, das dauert ein paar Minuten",
    failedState: "Fehlgeschlagen",
    busy: "Für dieses Projekt läuft schon ein Render.",
    play: "Abspielen",
  },
  account: {
    title: "Deine Projekte",
    emailPrompt: "Gib die E-Mail an, mit der du bestellt hast. Wir schicken dir einen Anmelde-Link.",
    send: "Anmelde-Link senden",
    sent: "Falls es zu dieser Adresse ein Konto gibt, ist ein Anmelde-Link unterwegs (30 Minuten gültig).",
    empty: "Noch keine Projekte.",
    buildStarts: "Baustart",
    hosting: "Hosting/Monat",
    total: "Bestellsumme",
    logout: "Abmelden",
  },
  ads: {
    campaignsTitle: "Kampagnen",
    campaignsIntro: "Anzeigen auf den Werbekonten von Codemenschen. Erstellt pausiert, du schaltest sie frei.",
    noCampaigns: "Noch keine Kampagnen.",
    platformOff: "nicht verbunden",
    publish: "Pausiert anlegen",
    activate: "Freischalten (Budget läuft)",
    pauseAd: "Pausieren",
    stUnpublished: "nicht angelegt",
    stPublishing: "wird angelegt",
    stPaused: "pausiert, bereit",
    stActive: "läuft",
    stFailed: "Fehler",
    problems: "Zu klären",
  },
  proto: {
    navLink: "Prototyp testen",
    title: "Prototyp in einer Minute",
    lead: "Beschreib deine Idee in einem Satz. Wir bauen dir sofort eine klickbare Vorschau, kostenlos.",
    label: "Was möchtest du bauen?",
    hint: "Zum Beispiel: eine Landingpage für ein Friseurstudio mit Online-Terminbuchung und Preisliste.",
    kindLabel: "Was sollen wir dir zeigen?",
    kinds: { site: "Website", app: "App", ads: "Werbung" },
    kindHints: {
      site: "Eine klickbare Startseite mit allem, was ein Kunde vor dem Anruf wissen will.",
      app: "Vier Bildschirme deiner App auf dem Handy, so wie sie sich bedienen würde.",
      ads: "Fünf fertige Anzeigen in den Größen, die Meta und Google tatsächlich ausspielen.",
    },
    hints: {
      site: "Zum Beispiel: eine Startseite für ein Friseurstudio in Wien mit Preisliste und Online-Terminbuchung.",
      app: "Zum Beispiel: eine App, mit der Stammkunden ihren Friseurtermin selbst buchen und verschieben.",
      ads: "Zum Beispiel: Anzeigen für ein Friseurstudio in Wien, die neue Kunden zur Online-Buchung bringen.",
    },
    go: "Prototyp bauen",
    building: "Wird gebaut, einen Moment…",
    failed: "Das hat nicht geklappt. Versuch es nochmal.",
    expired: "Dieser Prototyp ist abgelaufen.",
    shareTitle: "Dein Prototyp",
    shareHint: "Diese Vorschau ist ein paar Tage gültig. Teile den Link oder lass uns daraus eine echte App bauen.",
    makeReal: "Daraus eine echte App machen",
    another: "Noch einen bauen",
    limit: "Tageslimit erreicht. Morgen wieder oder schreib uns.",
    tooLong: "Das sind mehr als {max} Zeichen. Kürz es ein wenig und versuch es nochmal.",
    mine: "Deine Prototypen",
    mineHint: "Nur auf diesem Gerät gespeichert. Wir legen dazu nichts an und schicken nichts weg.",
    daysLeft: "noch {n} Tage",
    oneDayLeft: "noch 1 Tag",
    forget: "Entfernen",
    stages: {
      studying: "Schaut sich die Besten der Branche an, bevor gezeichnet wird.",
      writing: "Schreibt gerade die Seite. Das dauert zwei bis vier Minuten.",
      auditing: "Öffnet die Seite im Browser und prüft sie auf drei Bildschirmgrößen.",
      repairing: "Bessert nach, was die Prüfung gefunden hat.",
      photos: "Sucht passende Fotos.",
    },
    steps: {
      studying: "Branche anschauen",
      writing: "Seite schreiben",
      auditing: "Prüfen",
      repairing: "Nachbessern",
      photos: "Fotos einsetzen",
    },
    elapsed: "{t} vergangen, insgesamt meist 4 bis 6 Minuten.",
  },
  legal: {
    draft: "Entwurf. Das ist die Klartext-Fassung, geschrieben von uns und noch nicht anwaltlich freigegeben. Wir stellen sie trotzdem online, weil Vertrag und Werbung nie zwei verschiedene Geschichten erzählen dürfen.",
    updated: "Stand: 3. September 2026",
    impressum: "Impressum",
    terms: {
      title: "Bedingungen",
      lede: "Was du bestellst, was es kostet, wem die fertige App gehört und was passiert, wenn etwas schiefgeht.",
      sections: [
        {
          h: "1. Wer verkauft",
          p: [
            "Appwerk ist ein Angebot der Codemenschen GmbH in Wien. Die vollständigen Firmendaten stehen im Impressum.",
            "Vertragspartner sind du und die Codemenschen GmbH. Wir bauen Software im Auftrag. Wir vermitteln nichts und betreiben keinen Marktplatz für fremde Anbieter.",
          ],
        },
        {
          h: "2. Was du bekommst",
          p: [
            "Wir bauen die App nach dem Brief, den du im Assistenten beschreibst, testen sie und übergeben sie fertig.",
            "Die fertige App gehört dir: Code, App und Store-Eintrag. Wir behalten keinen Anteil an deinen Einnahmen, und dieselbe App wird nicht an jemand anderen weitergegeben.",
          ],
        },
        {
          h: "3. Was du zahlst",
          p: [
            "Der Entwicklungspreis steht vor der Zahlung fest und ist heute fällig. Optionale Pakete werden im Checkout einzeln ausgewiesen.",
            "Verbundene Apps laufen auf unseren Servern und haben ab Übergabe eine monatliche Gebühr für Hosting und Wartung. Der Betrag steht im Checkout, bevor du zahlst.",
            "Ein Werbebudget ist optional, wird getrennt abgerechnet und geht 1:1 in die Anzeigen. Es ist nie Teil der heutigen Zahlung.",
          ],
        },
        {
          h: "4. Wie gebaut wird",
          p: [
            "Der Bau läuft in Stufen. Du bekommst eine Vorschau und gibst sie frei, bevor es weitergeht.",
            "Änderungswünsche nach der Vorschau sind vorgesehen. Wie viele Runden enthalten sind und was eine weitere kostet, siehst du in deinem Projekt im Portal, bevor du sie auslöst.",
          ],
        },
        {
          h: "5. Baustart und Widerruf",
          p: [
            "Als Verbraucherin oder Verbraucher hast du 14 Tage Widerrufsrecht.",
            "Im Checkout entscheidest du selbst. Entweder wir starten sofort, dann erlischt das Widerrufsrecht mit Beginn der Leistung (§ 18 FAGG). Oder wir starten nach Ablauf der 14 Tage, dann bleibt es vollständig erhalten. Das Kästchen ist nie vorausgewählt.",
            "Die Einzelheiten stehen in der Widerrufsbelehrung.",
          ],
        },
        {
          h: "6. Werbung",
          p: [
            "Nichts wird veröffentlicht, bevor du es freigegeben hast. Kampagnen werden pausiert angelegt, erst dein Klick startet die Ausgaben.",
            "Du kannst das Budget monatlich ändern oder ganz stoppen.",
          ],
        },
        {
          h: "7. Was wir nicht versprechen",
          p: [
            "Wir versprechen keinen Umsatz, keine Downloads und keine Platzierung im Store. Zahlen auf dieser Website sind Schätzungen und als solche gekennzeichnet.",
            "Über die Aufnahme in ihre Stores entscheiden Apple und Google selbst. Wir bereiten die Einreichung vor und begleiten sie, zusagen können wir sie nicht.",
          ],
        },
        {
          h: "8. Recht",
          p: [
            "Es gilt österreichisches Recht. Zwingende Verbraucherrechte deines Wohnsitzstaates bleiben unberührt.",
          ],
        },
      ],
    },
    withdrawal: {
      title: "Widerrufsbelehrung",
      lede: "Dein 14-tägiges Widerrufsrecht, und die Wahl, die du im Checkout selbst triffst.",
      sections: [
        {
          h: "Das Recht",
          p: [
            "Als Verbraucherin oder Verbraucher in der EU kannst du binnen 14 Tagen ohne Angabe von Gründen widerrufen. Die Frist beginnt mit dem Vertragsabschluss.",
            "Für den Widerruf genügt eine eindeutige Erklärung an office@codemenschen.at vor Ablauf der Frist. Wir bestätigen den Eingang und erstatten erhaltene Zahlungen unverzüglich zurück.",
          ],
        },
        {
          h: "Deine Wahl im Checkout",
          p: [
            "Sofort starten: Du verlangst ausdrücklich, dass wir gleich nach der Zahlung mit dem Bau beginnen, und nimmst zur Kenntnis, dass dein Widerrufsrecht mit Beginn der Leistung erlischt (§ 18 FAGG). Das Kästchen ist nie vorausgewählt, und du bekommst die Bestätigung per E-Mail.",
            "Später starten: Ohne dieses Häkchen beginnt der Bau erst nach den 14 Tagen. Dein Widerrufsrecht bleibt vollständig erhalten. An der App ändert das nichts, sie startet nur später.",
          ],
        },
        {
          h: "Was noch offen ist",
          p: [
            "Die gesetzliche Musterbelehrung samt Formular und die genaue Einordnung des Vertrags werden gerade anwaltlich geprüft. Bis dahin gilt: Im Zweifel entscheiden wir zu deinen Gunsten.",
          ],
        },
      ],
    },
  },
  footer: {
    legal: "Bedingungen und Widerrufsbelehrung stehen als Klartext-Entwurf online, die anwaltliche Freigabe läuft. Datenschutz und Impressum folgen.",
    by: "Betrieben von der Codemenschen GmbH, Wien, Österreich.",
    imprint: "Impressum",
  },
};
